<template>
  <div>
    <base-crud
      crud-name="Horas Adicionais"
      new-text="Nova Hora adicional"
      :table="tableName"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="true"
      :enable-edit="true"
      :enable-delete="true"
      :enable-view="false"
      :data-form="dataForm"
    />
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function msToTime(duration) {
  console.log(duration)
  const milliseconds = parseInt((duration % 1000) / 100)
  let seconds = Math.floor((duration / 1000) % 60)
  let minutes = Math.floor((duration / (1000 * 60)) % 60)
  let hours = Math.floor(duration / (1000 * 60 * 60))

  hours = hours < 10 ? `0${hours}` : hours
  minutes = minutes < 10 ? `0${minutes}` : minutes
  seconds = seconds < 10 ? `0${seconds}` : seconds

  return `${hours}:${minutes}:${seconds}`
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      tableName: 'aditionalHourTable',
      users: [],
      pages: [],
      url: '',
      columns: [
        'id',
        'user_id',
        'responsible_id',
        'miliseconds',
        'created_at',
        'actions',
      ],
      tableData: [
        'id',
        'user_id',
        'responsible_id',
        'miliseconds',
        'created_at',
      ],
      options: {
        filterByColumn: true,
        filterable: [
          'id',
          'user_id',
          'responsible_id',
          'miliseconds',
          'created_at',
        ],
        sortable: [
          'id',
          'user_id',
          'responsible_id',
          'miliseconds',
          'created_at',
        ],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          user_id: 'Usuário',
          responsible_id: 'Responsável',
          miliseconds: 'Tempo',
          created_at: 'Criado em',
          actions: 'Ações',
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['user', 'responsible']

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
        templates: {
          user_id(h, row, index) {
            return row.user.name
          },
          responsible_id(h, row, index) {
            return row.responsible.name
          },
          miliseconds(h, row, index) {
            return msToTime(row.miliseconds)
          },
        },
      },
      endPoint: 'aditionalHours/',

      dataForm: {},
    }
  },
  methods: {
    query(query) {
      const columns = {
        id: 'id',
        user_id: 'user[name]',
        responsible_id: 'responsible[name]',
        miliseconds: 'miliseconds',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
